import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { EmptyState } from "@/components/storefront/common";
import ReviewGallery from "@/components/storefront/ReviewGallery";
import { Star, MessageSquare } from "lucide-react";

const BADGE = { approved: "bg-emerald-50 text-emerald-700", pending: "bg-amber-50 text-amber-700", rejected: "bg-red-50 text-red-600", hidden: "bg-slate-100 text-slate-500" };

export default function AccountReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/reviews/mine").then(({ data }) => setReviews(data.reviews)).finally(() => setLoading(false)); }, []);

  if (!loading && reviews.length === 0)
    return <EmptyState icon={MessageSquare} title="No reviews yet" text="Reviews you write will appear here."><Link to="/shop" className="bg-slate-900 text-white font-semibold px-5 py-2.5 rounded-lg">Browse Products</Link></EmptyState>;

  return (
    <div className="space-y-3">
      <h2 className="font-semibold text-slate-900 text-lg mb-2">My Reviews</h2>
      {reviews.map((r) => (
        <div key={r.id} className="rounded-xl border border-slate-200 bg-white p-4">
          <div className="flex items-center justify-between">
            <p className="font-medium text-slate-900 text-sm">{r.productName}</p>
            <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${BADGE[r.status] || BADGE.pending}`}>{r.status}</span>
          </div>
          <div className="flex mt-1">{Array.from({ length: 5 }).map((_, i) => <Star key={i} className={`h-3.5 w-3.5 ${i < r.rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />)}</div>
          <p className="text-sm text-slate-600 mt-1">{r.comment}</p>
          <ReviewGallery images={r.images} size="sm" />
        </div>
      ))}
    </div>
  );
}
